import React from 'react'
import { Select } from 'antd'

export interface OptionType {
  label: string
  value: string | number
}

interface CustomDropdownProps {
  options: OptionType[]
  defaultValue?: OptionType | string | null | any // Change to expect an object
  value?: OptionType | string | null | any // Change to expect an object
  className?: string
  placeholder?: string
  modal?: boolean
  onChange?: (value: any) => void
}

const CustomSelect: React.FC<CustomDropdownProps> = ({
  options,
  defaultValue,
  value,
  className,
  placeholder,
  modal,
  onChange,
}) => {
  // Determine the popup container based on the `modal` prop
  const getPopupContainer = modal
    ? () =>
        (document.getElementsByClassName('modal')[0] as HTMLElement) ||
        document.body
    : undefined

  return (
    <Select
      defaultValue={defaultValue}
      className={className}
      placeholder={placeholder ? placeholder : 'Select'}
      style={{ width: '100%' }}
      getPopupContainer={getPopupContainer}
      options={options}
      value={value}
      onChange={onChange}
    />
  )
}

export default CustomSelect
